import { T } from "@tolgee/react";
import { FC } from "react";

interface MenuSectionLabelProps {
  label: string;
}

export const MenuSectionLabel: FC<MenuSectionLabelProps> = ({ label }) => {
  return (
    <div className="md:hidden text-xs font-medium leading-[16px] text-gray-500 pb-2.5">
      <T keyName={label} />
    </div>
  );
};
